// The four fixed template types. Template *content* (subject, body, variables)
// lives in the database and comes from the API. The card label/description and
// whether a type shows action buttons are pure UI metadata and live here.

export type TemplateType =
    | "approval"
    | "feedback"
    | "inform"
    | "escalate";

export interface TemplateTypeMeta {
    key: TemplateType;
    label: string;
    description: string;
    hasActions?: boolean;
}

export const TYPE_LIST: TemplateTypeMeta[] = [
    { key: "approval", label: "Approval", description: "Sent to an approver when an action needs a decision.", hasActions: true },
    { key: "feedback", label: "Feedback", description: "Ask a recipient to share feedback." },
    { key: "inform", label: "Inform", description: "Share progress or a status change — no action needed." },
    { key: "escalate", label: "Escalate", description: "Escalate an action to a higher approver.", hasActions: true },
];

const BY_KEY: Record<TemplateType, TemplateTypeMeta> = TYPE_LIST.reduce((acc, t) => {
    acc[t.key] = t;
    return acc;
}, {} as Record<TemplateType, TemplateTypeMeta>);

export function isTemplateType(value?: string): value is TemplateType {
    return !!value && value in BY_KEY;
}

export function getTypeMeta(type?: string): TemplateTypeMeta {
    return isTemplateType(type) ? BY_KEY[type] : TYPE_LIST[0];
}
